(function () {
  const body = document.body;
  const interstitial = document.querySelector('.js-interstitial');

  if (typeof componentEvents !== 'undefined' && interstitial) {
    componentEvents.on('show-interstitial', showInterstitial);
    componentEvents.on('hide-interstitial', hideInterstitial);
  }

  function showInterstitial() {
    body.dataset.previousScrollTop = (document.documentElement.scrollTop || body.scrollTop);
    body.style.top = (-1 * body.dataset.previousScrollTop) + 'px';
    body.classList.add('js-interstitial-open');
  }

  function hideInterstitial() {
    body.classList.remove('js-interstitial-open');
    document.documentElement.scrollTop = body.scrollTop = body.dataset.previousScrollTop;
    body.style.top = '';
    delete body.dataset.previousScrollTop;
  }
})();
